import { render, staticRenderFns } from "./BroadcastMsg.vue?vue&type=template&id=01cd2ace&scoped=true&"
import script from "./BroadcastMsg.vue?vue&type=script&lang=js&"
export * from "./BroadcastMsg.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMsg.vue?vue&type=style&index=0&id=01cd2ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd2ace",
  null
  
)

export default component.exports